if (!customElements.get('nv-cart-recommendation')) customElements.define('nv-cart-recommendation', class extends HTMLElement {
 connectedCallback() {
  this.controller?.abort(); this.controller = new AbortController();
  const options = {signal:this.controller.signal};
  const button=this.querySelector('[data-add-button]');
  const select=this.querySelector('[data-variant-select]');
  select?.addEventListener('change',()=>{
   const option=select.selectedOptions[0];this.dataset.variantId=option.value;
   this.querySelector('[data-price-display]').textContent=option.dataset.price;
   this.querySelector('[data-price-display]').classList.toggle('cart-rec-card__sale-price--on-sale',!!option.dataset.comparePrice);
   let compare=this.querySelector('[data-compare-price-display]');
   if(!compare){compare=document.createElement('span');compare.className='cart-rec-card__compare-price';compare.dataset.comparePriceDisplay='';this.querySelector('[data-prices-container]').prepend(compare);}
   compare.textContent=option.dataset.comparePrice||'';compare.hidden=!option.dataset.comparePrice;
   const promo=this.querySelector('[data-dnes-rec-price]'),tpl=this.querySelector('template[data-dnes-rec-variant="'+option.value+'"]');if(promo&&tpl)promo.replaceChildren(tpl.content.cloneNode(true));
   const img=this.querySelector('[data-variant-image]');if(img&&option.dataset.image)img.src=option.dataset.image;
  },options);
  button.addEventListener('click',async()=>{
   if(button.disabled)return;
   button.disabled=true;if(select)select.disabled=true;
   const label=this.querySelector('[data-add-text]');label.textContent='Přidávám…';
   const error=this.querySelector('[role=alert]');error.hidden=true;
   try {
    const response=await fetch(this.dataset.cartAddUrl,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(this.dataset.variantId),quantity:1}]})});
    if(!response.ok){const data=await response.json().catch(()=>({}));throw new Error(data.description||'Produkt se nepodařilo přidat. Obnovte košík a ověřte jeho obsah.');}
    button.dataset.added='true';
    // Keep the confirmation in place before the standard drawer refresh removes this recommendation.
    await new Promise(resolve=>setTimeout(resolve,1400));
    const cartResponse=await fetch('/cart.js');
    if(!cartResponse.ok)throw new Error('Přidáno. Obnovte košík pro aktuální součet.');
    const cart=await cartResponse.json();
    document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:cart,data:{source:'recommendation-card',itemCount:cart.item_count,variantId:this.dataset.variantId}}}));
   } catch(e) {
    label.textContent='Ověřit košík';error.textContent=e.message||'Ověřte obsah košíku před dalším přidáním.';error.hidden=false;
   }
  },options);
 }
 disconnectedCallback(){this.controller?.abort();}
});
